import { Skeleton } from "../ui";
import "./RouteFallback.scss";

const STAT_CARD_COUNT = 4;
const ROW_COUNT = 6;

// Previously rendered as a bare empty div - a genuine loading state (lazy
// chunk fetch, permissions not ready yet) was visually indistinguishable
// from a broken/blank page, since there was nothing on screen either way.
// A generic list-page-shaped skeleton (rather than a spinner) since this is
// the shared fallback for every lazy route/permission gate and can't know
// the destination page's real shape up front - most routes are list pages,
// so that's the closest generic approximation.
const RouteFallback = () => (
  <div className="route-fallback" aria-busy="true" role="status">
    <div className="route-fallback__header">
      <Skeleton width="180px" height="22px" />
      <div className="route-fallback__header-actions">
        <Skeleton width="90px" height="34px" radius="6px" />
        <Skeleton width="90px" height="34px" radius="6px" />
      </div>
    </div>

    <div className="route-fallback__stats">
      {Array.from({ length: STAT_CARD_COUNT }).map((_, i) => (
        <Skeleton key={i} width="100%" height="72px" radius="10px" />
      ))}
    </div>

    <div className="route-fallback__table">
      <Skeleton width="100%" height="40px" radius="8px" />
      {Array.from({ length: ROW_COUNT }).map((_, i) => (
        <Skeleton key={i} width="100%" height="44px" radius="6px" />
      ))}
    </div>
  </div>
);

export default RouteFallback;
